import { FC, useCallback, useState, useEffect } from 'react';
import modalClasses from '../asset/css/common-modal.module.css';

export const CommonModal: FC<{
  active: boolean;
  scrollOffset: number;
  parentViewportHeight: number;
  marginToTop: number;
  closeFunc: () => void;
  content: JSX.Element;
}> = ({ active, scrollOffset, parentViewportHeight, marginToTop, closeFunc, content }) => {
  const [beforeActive, setBeforeActive] = useState(false);
  const [marginTop, setMarginTop] = useState(0);

  if (beforeActive !== active) {
    setBeforeActive(active);
    //if (active) {
    //  setMarginTop(scrollOffset + 30);
    //}
  }

  const bgClickHandler = useCallback(
    (e) => {
      if (e.target.className !== modalClasses.mypage_popup_bg) return;

      closeFunc();
    },
    [closeFunc]
  );

  const closeBtnClickHandler = useCallback(() => {
    closeFunc();
  }, [closeFunc]);

  useEffect(() => {
    const popupHeight = 288;
    const margin = (parentViewportHeight - popupHeight) / 2;
    const result = scrollOffset - marginToTop + margin;

    setMarginTop(result);
  }, [scrollOffset, parentViewportHeight, marginToTop]);

  return (
    <>
      <div className={modalClasses.mypage_popup_bg} style={active ? {} : { display: 'none' }} onClick={bgClickHandler}>
        <div className={modalClasses.mypage_popup} style={{ marginTop: `${marginTop}px` }}>
          <button className={modalClasses.mypage_popup_close} onClick={closeBtnClickHandler} />
          <div className={modalClasses.mypage_popup_in}>{content}</div>
        </div>
      </div>
    </>
  );
};
